import React from "react";
import { FaMapMarkerAlt, FaEnvelopeOpen, FaPhoneAlt, FaWhatsapp, FaArrowRight } from "react-icons/fa";
import { motion } from "framer-motion";
import YatraExpertsSection from "../../pages/yatra/YatraExpertsSection";

const ContactForm = ({ showMap = false }) => {
  return (
    <section className="relative bg-white overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-orange-main/5 blur-[120px] rounded-full -mr-64 -mt-64 pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-teal-main/5 blur-[100px] rounded-full -ml-48 -mb-48 pointer-events-none" />

      <div className="relative z-10">

        <YatraExpertsSection />
        {/* MAP SECTION */}
        {showMap && (
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
          
          >
            <iframe
              title="map"
              src="https://www.google.com/maps?q=Opp.%20Shilpgram,%20Near%20Poddar%20Chowk,%20Khajuraho,%20Chhatarpur%20471606%20Madhya%20Pradesh,%20India&output=embed"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full h-[500px] grayscale hover:grayscale-0 transition-all duration-1000"
            />
          </motion.div>
        )}
      </div>
    </section>
  );
};

const ContactInfoItem = ({ icon, title, detail, link }) => (
  <div className="flex items-start gap-6 group">
    <div className="w-14 h-14 rounded-2xl bg-white shadow-xl shadow-black/5 flex items-center justify-center text-xl text-orange-main group-hover:bg-orange-main group-hover:text-white transition-all duration-500 shrink-0">
      {icon}
    </div>
    <div>
      <p className="text-xs font-black uppercase tracking-widest text-gray-400 mb-1">{title}</p>
      {link ? (
        <a href={link} className="text-lg font-bold text-gray-900 hover:text-orange-main transition-colors">
          {detail}
        </a>
      ) : (
        <p className="text-lg font-bold text-gray-900">{detail}</p>
      )}
    </div>
  </div>
);

export default ContactForm;
